import { render, staticRenderFns } from "./RightsFundRollback.vue?vue&type=template&id=692615e9"
import script from "./RightsFundRollback.vue?vue&type=script&lang=js"
export * from "./RightsFundRollback.vue?vue&type=script&lang=js"
import style0 from "./RightsFundRollback.vue?vue&type=style&index=0&id=692615e9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports